import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65a681cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_2 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, { class: "com-wrap-box" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_ui_form, {
        "label-position": "right",
        "label-width": "150px",
        ref: "form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "员工添加" })
            ]),
            default: _withCtx(() => [
              (!_ctx.formData.id)
                ? (_openBlock(), _createBlock(_component_ui_form_item, {
                    key: 0,
                    label: "手机",
                    data: _ctx.formData.phone
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.phone,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.phone) = $event)),
                        placeholder: "请输入员工手机，作为账号登陆"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["data"]))
                : (_openBlock(), _createBlock(_component_ui_form_item, {
                    key: 1,
                    label: "手机",
                    data: _ctx.formData.phone
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formData.phone), 1)
                    ]),
                    _: 1
                  }, 8, ["data"])),
              _createVNode(_component_ui_form_item, {
                label: "姓名",
                data: _ctx.formData.name
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.name) = $event)),
                    placeholder: "请输入员工姓名"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_ui_form_item, { label: "员工角色" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleList, (item, i) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      onChange: ($event: any) => (_ctx.changeCheck(item, $event)),
                      modelValue: _ctx.checkHash[item.id],
                      key: i
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onChange", "modelValue"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _ctx.submit,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_loading, _ctx.submitLoading]
            ])
          ])
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }))
}